import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, CheckBoxWithLabel, CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, EntityStatus, FormActions, FormatPrice, TiposVehiclos, TipoVehiculoEntity, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";









const schema = yup.object({
  cod_cia:yup.string().required(),
  margen: yup.number().min(0).required(),
  credito_preaprobado: yup.number().min(0).required(),
  descripcion: yup.string().required(),
  cod_erp: yup.string().notRequired().nullable().optional(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestrosClasificacionClientes = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [companyList,setCompanyList] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
      await loadCompanyes();
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
    const loadCompanyes = async()=>{
      const  {data:{value}} = await AxiosInstance.get("maestros/listar-companias");
      setCompanyList(value);
    }
    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros-marketplace/get-clasificacion-clientes",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };


    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  {...dataSetProdctos.find(prod=>prod.cod === cod_prod)};
      product.cant_minima_compra = Number(product.cant_minima_compra)
      setProductoSeleccionado(product);
      setTipoAction(FormActions.MODIFICAR);


    }

    const onOpenModalItem = (edit=false)=>{
      setTipoAction(FormActions.AGREGAR);
      setProductoSeleccionado({});
      setIsVisibleModalDetalle(true);

    
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      console.log({typeAction,dataForm});
  
      const urlService = typeAction === FormActions.AGREGAR?'maestros-marketplace/add-clasificacion-clientes':'maestros-marketplace/edit-clasificacion-clientes/'+dataForm.cod;
         
        let payload =  {...dataForm,nombre_compania:undefined,lista_precio_cod:undefined,lista_precio_des:undefined  };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }


    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }
    const searchCpAsociado = async (event, newInputValue) => {
      await loadCentrosOp(newInputValue.toLowerCase());
     
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"descripcion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"Cod erp",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"margen",
        keyValue:"margen",
        label:"Margen Objetivo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
        key:"cant_minima_compra",
        keyValue:"cant_minima_compra",
        label:"Valor minimo de compra",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>`$ ${FormatPrice(props.value)} COP`,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
        },
        {
          key:"credito_preaprobado",
          keyValue:"credito_preaprobado",
          label:"Credito preaprobado",
          headerRender:(props)=>props.label,
          bodyRender:(props)=>`$ ${FormatPrice(props.value || 0)} COP`,
          typeRow:"number",
          sort:false,
          sortFunction:()=>{},
          sortStatus:"", 
          },
        {
          key:"nombre_compania",
          keyValue:"nombre_compania",
          label:"Compañia",
          headerRender:(props)=>props.label,
          bodyRender:(props)=>props.value,
          typeRow:"number",
          sort:false,
          sortFunction:()=>{},
          sortStatus:"", 
          },

      {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar clasificacion cliente":'Modificar clasificacion cliente',
      buttomsAction: [
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"cod_cia",
          keyValue:"cod_cia",
          label:"Compañia",
          responsiveSize:6,
          component:SelectInputWithLabel,
          inputProps:{
            type:"number",
            size:"small",
            items:companyList
          }
        },
        {
          key:"descripcion",
          keyValue:"descripcion",
          label:"Descripcion",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"margen",
          keyValue:"margen",
          label:"Margen Objetivo",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small"
          }
        },

        {
          key:"credito_preaprobado",
          keyValue:"credito_preaprobado",
          label:"Credito preaprobado",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small"
     
          }
        },

      ],
      arrayInputs:[]
    } ;

    return (<>
   {
    isVisibleModalDetalle && 
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    /> 
   }
   
    <Grid container spacing={2} >

        <Grid item sm={12} xs={12} md={12} >
          <Button size="small"  disabled={ !["administrador","administrador-punto-venta"].includes( profile.perfil.descripcion)}  variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nueva clasificacion</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}